import styles from './styles.module.css';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import i18n from 'i18next';
import { Link } from 'react-router-dom';
import { LANGUAGES } from '../../utils/Constants';
import ic_Next from '../../assets/imgs/ic_Next.svg?react';

/**
 * マイページの項目のカスタマイズ
 */
interface MyProfileItemProps {
    to?: string;
    title?: string;
    isIcon?: boolean;
    onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLDivElement>;
    isDescription?: boolean;
}
const MyProfileItem = memo(({ to, title, isIcon = true, onClick, isDescription = false }: MyProfileItemProps) => {
    /**
     * 言語項目のサブタイトルを表示
     *
     * @returns {HTMLElement}
     */
    const showDescription = () => {
        if (isDescription) {
            const lang = LANGUAGES.find((language) => language.key === i18n.language);
            return (
                <div className={styles.description}>
                    <span>{lang?.title}</span>
                    <span>{lang?.subTitle}</span>
                </div>
            );
        }
    };

    return (
        <div className={styles.myProfileItemContainer}>
            {to ? (
                <Link to={to} className={styles.rowItem} onClick={onClick}>
                    {isIcon && React.createElement(ic_Next, { className: styles.icImage })}
                    <div className={styles.titleContent}>
                        <p style={{ fontWeight: 'bold' }}>{title}</p>
                        {showDescription()}
                    </div>
                </Link>
            ) : (
                <div className={styles.rowItem} onClick={onClick} role="button" tabIndex={0}>
                    {isIcon && React.createElement(ic_Next, { className: styles.icImage })}
                    <div className={styles.titleContent}>
                        <p style={{ fontWeight: 'bold' }}>{title}</p>
                        {showDescription()}
                    </div>
                </div>
            )}
        </div>
    );
});

MyProfileItem.prototype = {
    to: PropTypes.string,
    title: PropTypes.string,
    isIcon: PropTypes.bool,
};

export default MyProfileItem;
